import { LogApi } from 'api'
import { ERROR } from 'modules/logging/errors'
import { log } from 'utils'


export enum LogLevel {
  DEBUG="DEBUG", INFO="INFO", LOG="LOG", WARN="WARNING", ERROR="ERROR"
}

export interface LogEvent {
  timestamp: number
  level?: LogLevel
  message: string
}

export interface LogPayload {
  application: string,
  orgId: number,
  endUserId: number,
  logEvents: LogEvent[]
}

export const sendLogs = (payload: LogPayload) => {
  LogApi.post(`/log`, payload).catch(e => {
    log({ data: [ERROR.LOG.SEND_FAILURE, e] })
  })
}
